{
  "actionModals": {
    "assign": {
      "aria": "Assigner un vendeur",
      "overrideScore": "Forcer le score gagnant (choix imposé par l'admin)",
      "reasonLabel": "Raison (≥ 10 caractères)*",
      "submit": "Assigner le vendeur",
      "submitting": "Assignation…",
      "subtitle": "Assigner ou changer le vendeur de cette commande. La raison doit comporter au moins 10 caractères — elle sera enregistrée dans le journal d'audit.",
      "title": "Assigner / Réassigner un vendeur",
      "toastError": "Échec de l'assignation du vendeur",
      "toastSuccess": "Vendeur assigné",
      "vendorLabel": "Vendeur*",
      "vendorPlaceholder": "Choisir un vendeur…"
    },
    "cancel": {
      "aria": "Annuler la commande",
      "cancelAllItems": "annuler tous les articles",
      "compAmountLabel": "Compensation (USD)*",
      "compEnable": "Émettre une compensation au vendeur",
      "compLegend": "Compensation vendeur",
      "compReasonLabel": "Raison de la compensation*",
      "irreversibleAck": "Je confirme comprendre que cette action est permanente.",
      "irreversibleBody": "Une fois la commande passée à l'état annulé, le système n'a aucun moyen de la restaurer — si un retraitement est nécessaire, le marchand doit créer une nouvelle commande (hors de ce flux d'annulation + remboursement). Assurez-vous d'avoir choisi le bon mode (douce / forcée), les bons articles (ou toute la commande) et que la politique de remboursement correspond à l'accord avec le marchand.",
      "irreversibleTitle": "Cette action est irréversible.",
      "itemMeta": "qté {{qty}} · {{status}}",
      "itemsLegend": "Articles à annuler (vide = tous)",
      "modeForce": "Annulation forcée",
      "modeSoft": "Annulation douce (articles annulables uniquement)",
      "notifyMerchant": "Notifier le marchand (e-mail)",
      "reasonCodeLabel": "Code de raison*",
      "reasonTextLabel": "Texte de la raison (≥ 10 caractères)*",
      "refundAmountLabel": "Montant du remboursement (USD)*",
      "refundPolicyLegend": "Politique de remboursement",
      "refundPolicyOptions": {
        "full": "total",
        "none": "aucun",
        "partial": "partiel"
      },
      "selectAll": "Tout sélectionner ({{count}})",
      "selectedCount": "{{selected}}/{{total}} sélectionnés",
      "submit": "Annuler la commande (permanent)",
      "subtitle": "Annuler la commande avec remboursement + compensation vendeur. Remboursement > 500 $ ou annulation forcée d'une commande > 1000 $ → double approbation.",
      "title": "Annuler la commande",
      "toastDualApprovalDesc": "Seuil — en attente d'un second approbateur (id {{id}}).",
      "toastDualApprovalTitle": "Passé en double approbation",
      "toastError": "Échec de l'annulation de la commande",
      "toastSuccess": "Commande annulée"
    },
    "common": {
      "cancel": "Annuler",
      "centsLine": "= {{cents}} cents",
      "clear": "Effacer",
      "processing": "Traitement…"
    },
    "reasonCodes": {
      "CHANGED_MIND": "Changement d'avis",
      "CUSTOMER_REQUEST": "Demande du client",
      "DUPLICATE_ORDER": "Commande en double",
      "FRAUD_SUSPECTED": "Fraude suspectée",
      "OTHER": "Autre",
      "POLICY_VIOLATION": "Violation de politique",
      "SYSTEM_ERROR": "Erreur système",
      "VENDOR_FAILURE": "Échec du vendeur",
      "WRONG_ADDRESS": "Mauvaise adresse",
      "WRONG_ARTWORK": "Mauvais visuel",
      "WRONG_PRODUCT": "Mauvais produit"
    },
    "refund": {
      "amountLabel": "Montant du remboursement (USD)*",
      "aria": "Rembourser la commande",
      "centsLine": "= {{cents}} cents · {{mode}}",
      "fullButton": "Total (${{amount}})",
      "modeFull": "remboursement total",
      "modePartial": "partiel",
      "noteLabel": "Note",
      "reasonCodeLabel": "Code de raison*",
      "submit": "Rembourser",
      "subtitle": "Créer un remboursement. Les remboursements > 500 $ passent en double approbation.",
      "title": "Remboursement",
      "toastError": "Échec du remboursement",
      "toastSuccess": "Demande de remboursement envoyée"
    },
    "resend": {
      "aria": "Réexpédier la commande",
      "costLabel": "Responsabilité des coûts*",
      "costOptions": {
        "platform": "plateforme (0/100)",
        "shared": "partagé (50/50)",
        "vendor": "vendeur (100/0)"
      },
      "reasonLabel": "Raison (≥ 10 caractères)*",
      "submit": "Réexpédier",
      "subtitle": "Créer un ordre de réimpression pour la commande. La responsabilité des coûts détermine qui paie.",
      "title": "Réexpédier / Réémettre",
      "toastError": "Échec de la réexpédition",
      "toastSuccess": "Ordre de réimpression créé",
      "vendorLabel": "Vendeur (vide = conserver le vendeur d'origine)",
      "vendorPlaceholder": "(remplacement optionnel)"
    },
    "surcharge": {
      "amountLabel": "Montant de la surcharge (USD)*",
      "aria": "Ajouter une surcharge",
      "paymentMethodLabel": "Mode de paiement (optionnel)",
      "paymentOptions": {
        "credit": "crédit",
        "default": "(utiliser par défaut)",
        "wallet": "portefeuille"
      },
      "reasonLabel": "Raison (≥ 10 caractères)*",
      "submit": "Ajouter la surcharge",
      "subtitle": "Créer une surcharge rattachée à la commande. La raison doit comporter au moins 10 caractères.",
      "title": "Ajouter une surcharge",
      "toastError": "Échec de l'ajout de la surcharge",
      "toastSuccess": "Surcharge ajoutée"
    }
  },
  "admin": {
    "sendOnBehalf": {
      "section": {
        "title": "Envoyer en production (admin)",
        "description": "Approuver et envoyer cette commande en attente en production au nom du marchand."
      },
      "button": "Envoyer en production (au nom du marchand)",
      "submitting": "Envoi…",
      "confirm": {
        "title": "Envoyer en production au nom du marchand ?",
        "body": "Cette action approuve la commande et la transmet à la production au nom du marchand. Le marchand sera notifié. Continuer ?",
        "confirmLabel": "Envoyer en production",
        "cancelLabel": "Annuler"
      },
      "success": "Commande envoyée en production au nom du marchand.",
      "successDesc": "{{count}} article(s) affecté(s) à la production.",
      "error": "Impossible d'envoyer la commande en production.",
      "errorInvalidState": "Cette commande n'est plus en attente d'approbation.",
      "errorNotFound": "Commande introuvable.",
      "blocked": {
        "title": "Illustration non validée",
        "body": "Un ou plusieurs articles sont bloqués car leur illustration n'est pas validée. Résolvez-les avant l'envoi en production.",
        "areasLabel": "Zones bloquantes :",
        "areaItem": "Zone {{area}} — {{status}}"
      }
    }
  },
  "chips": {
    "aria": "Sous-filtres des problèmes",
    "clear": "Effacer",
    "descriptions": {
      "dlq_failed": "Le worker en arrière-plan a atteint la file de lettres mortes (dead-letter queue).",
      "mapping_error": "Mappage SKU / capacité du vendeur manquant ou obsolète.",
      "quality_issue": "Production échouée au contrôle qualité du vendeur.",
      "shipping_problem": "Le transporteur a signalé une exception / un colis en échec."
    },
    "statusLabels": {
      "dlq_failed": "Échec DLQ",
      "mapping_error": "Erreur de mappage",
      "quality_issue": "Problème de qualité",
      "shipping_problem": "Problème d'expédition"
    },
    "subFilter": "Sous-filtre"
  },
  "csvImport": {
    "columns": {
      "error": "Erreur",
      "status": "Statut"
    },
    "page": {
      "description": "Téléversez un fichier CSV pour réattribuer le fournisseur de plusieurs commandes à la fois. Processus en 2 étapes : aperçu → confirmer l'application (tout ou rien).",
      "heading": "Importer un CSV pour réattribuer le fournisseur",
      "reasonHint": "minimum 20 caractères.",
      "requiredColumnsLabel": "Colonnes requises :"
    },
    "status": {
      "INVALID": "Erreur",
      "OK": "OK",
      "SKIP-cancelled": "Ignorée (annulée)",
      "SKIP-shipped": "Ignorée (expédiée)"
    },
    "step1": {
      "downloadTemplate": "Télécharger le modèle CSV",
      "heading": "Étape 1 — Téléverser le fichier CSV",
      "preview": "Aperçu",
      "previewing": "Aperçu en cours…",
      "selectedPrefix": "Sélectionné :"
    },
    "step2": {
      "applyConfirm": "Confirmer l'application ({{count}})",
      "applying": "Application en cours…",
      "downloadErrors": "Télécharger le rapport d'erreurs (.csv)",
      "heading": "Étape 2 — Aperçu des résultats",
      "invalidLabel": "Erreurs :",
      "moreRows": "Affichage de {{shown}} / {{total}} lignes. Téléchargez le rapport d'erreurs pour voir tous les détails.",
      "skipLabel": "Ignorées :",
      "totalLabel": "Total :",
      "validLabel": "Valides :"
    },
    "toast": {
      "applyFailTitle": "Échec de l'application",
      "applySuccessDesc": "Fournisseur réattribué pour {{count}} commandes.",
      "applySuccessTitle": "Application réussie",
      "emptyFileDesc": "Veuillez choisir un fichier CSV avec au moins 1 ligne de données.",
      "emptyFileTitle": "Fichier vide",
      "invalidResponseDesc": "Le serveur a renvoyé des données d'aperçu invalides.",
      "invalidResponseTitle": "Réponse invalide",
      "networkErrorDesc": "Impossible de se connecter au serveur",
      "networkErrorTitle": "Erreur réseau",
      "noFileDesc": "Veuillez choisir un fichier CSV avant l'aperçu.",
      "noFileTitle": "Aucun fichier sélectionné",
      "noValidRowsDesc": "Corrigez les erreurs puis téléversez à nouveau le CSV.",
      "noValidRowsTitle": "Aucune ligne valide",
      "previewReadyDesc": "{{valid}}/{{total}} lignes valides. Expire dans {{minutes}} minutes.",
      "previewReadyTitle": "Aperçu prêt",
      "tooLargeDesc": "Taille maximale 5 Mo. Le fichier actuel fait {{size}} Mo.",
      "tooLargeTitle": "Fichier trop volumineux",
      "unknownError": "Erreur inconnue",
      "uploadFailTitle": "Échec du téléversement",
      "wrongFormatDesc": "Veuillez choisir un fichier .csv",
      "wrongFormatTitle": "Mauvais format"
    }
  },
  "detail": {
    "back": "Retour aux commandes",
    "badRoute": {
      "body": "Veuillez revenir à la liste des commandes.",
      "title": "Commande invalide"
    },
    "loadError": "Impossible de charger les détails de la commande.",
    "loading": "Chargement de la commande…",
    "tabs": {
      "finance": "Finances",
      "history": "Historique et support",
      "overview": "Aperçu",
      "sectionsAria": "Sections du détail de la commande",
      "shipping": "Expédition"
    },
    "vendorOverride": {
      "button": "Modifier le fournisseur",
      "description": "Changer le fournisseur de cette commande. Simple transfert de propriété — ne déclenche PAS de nouvelle approbation.",
      "title": "Remplacer le fournisseur (admin)"
    }
  },
  "header": {
    "grandTotalLabel": "Total commande",
    "statusLabels": {
      "accepted": "Acceptée",
      "assigned": "Attribuée",
      "attention_required": "Attention requise",
      "cancelled": "Annulée",
      "confirmed": "Confirmée",
      "delivered": "Livrée",
      "draft": "Brouillon",
      "in_production": "En production",
      "on_hold": "En suspens",
      "partially_cancelled": "Partiellement annulée",
      "partially_shipped": "Partiellement expédiée",
      "pending_emb_payment": "Paiement broderie en attente",
      "pending_payment": "Paiement en attente",
      "pending_reassignment": "Réattribution en attente",
      "quality_check": "Contrôle qualité",
      "ready_to_ship": "Prête à expédier",
      "returned_partial": "Retour partiel",
      "shipped": "Expédiée",
      "unknown": "Inconnu"
    },
    "copyBarcode": "Copier le code-barres",
    "actions": {
      "assign": "Attribuer",
      "reassign": "Réattribuer",
      "refund": "Rembourser",
      "resend": "Renvoyer",
      "cancel": "Annuler la commande",
      "surcharge": "Ajouter un supplément"
    }
  },
  "leftColumn": {
    "adminNotes": {
      "empty": "Aucune note pour le moment.",
      "heading": "Notes internes",
      "loading": "Chargement…",
      "placeholder": "Note interne — visible par les admins uniquement.",
      "save": "Enregistrer",
      "saveFailed": "Échec de l'enregistrement de la note",
      "readOnly": "Vous n'avez pas la permission d'ajouter des notes internes — les notes existantes sont en lecture seule."
    },
    "compensationHistory": {
      "empty": "Aucune compensation pour le moment.",
      "heading": "Historique des compensations",
      "loading": "Chargement…"
    },
    "deliveryAddress": {
      "adjustedBadge": "Ajustée",
      "diffTitle": "Saisie client → Normalisée",
      "heading": "Adresse de livraison",
      "noAddress": "Cette commande n'a pas encore d'adresse de livraison."
    },
    "items": {
      "artworkAlt": "Visuel {{num}}",
      "artworkCount": "{{count}} fichier",
      "artworkLabelFallback": "Visuel",
      "artworkNone": "Aucun",
      "columns": {
        "artwork": "Visuel",
        "cogs": "COGS",
        "embroidery": "Broderie",
        "price": "Prix",
        "product": "Produit",
        "quantity": "Qté",
        "shippingFee": "Frais d'expédition",
        "sku": "SKU",
        "status": "Statut",
        "total": "Total",
        "unitPrice": "Prix unitaire",
        "vendor": "Fournisseur"
      },
      "download": "Télécharger le visuel",
      "empty": "Cette commande n'a pas encore d'article.",
      "expandHint": "Cliquez sur une ligne pour voir le visuel",
      "heading": "Articles ({{count}})",
      "lineTotal": "Total ligne",
      "noArtworkUpload": "Cet article n'a aucun visuel téléversé.",
      "thumbnailNa": "N/A",
      "unknownProduct": "Produit inconnu",
      "vendorFallback": "Fournisseur #{{id}}",
      "vendorUnassigned": "Non attribué",
      "totals": {
        "subtotal": "Sous-total",
        "embroidery": "Broderie",
        "shipping": "Livraison",
        "surcharge": "Supplément",
        "tax": "Taxe",
        "grandTotal": "Total général"
      }
    },
    "orderInfo": {
      "heading": "Informations de la commande",
      "labels": {
        "createdAt": "Créée le",
        "orderId": "ID de commande",
        "orderNumber": "Numéro de commande",
        "payment": "Paiement",
        "status": "Statut",
        "updatedAt": "Mise à jour le"
      }
    },
    "refundHistory": {
      "backendPending": "Les remboursements ne sont pas encore disponibles — ils apparaîtront une fois le système de remboursement déployé.",
      "empty": "Aucune demande de remboursement pour le moment.",
      "heading": "Historique des remboursements",
      "loading": "Chargement…",
      "statusLabels": {
        "approved": "Approuvé",
        "failed": "Échoué",
        "pending": "En attente",
        "rejected": "Rejeté",
        "settled": "Réglé"
      }
    },
    "relatedTickets": {
      "empty": "Aucun ticket lié — le module de support n'est pas encore déployé.",
      "heading": "Tickets liés",
      "loading": "Chargement…"
    },
    "shippingTracking": {
      "empty": "Aucune expédition pour le moment.",
      "errorHint": "Les informations de suivi seront disponibles une fois l'expédition confirmée par le fournisseur.",
      "heading": "Expédition & Suivi",
      "loading": "Chargement…"
    },
    "surchargeHistory": {
      "empty": "Aucun supplément.",
      "heading": "Historique des suppléments",
      "loading": "Chargement…"
    },
    "timeline": {
      "empty": "Aucun événement pour le moment.",
      "heading": "Chronologie",
      "loading": "Chargement…"
    }
  },
  "list": {
    "sub": {
      "unit": "Unité",
      "shipping": "Livraison",
      "total": "Total",
      "artworkOk": "Visuel",
      "artworkNone": "Sans visuel"
    },
    "actions": {
      "openOrderAria": "Ouvrir la commande {{orderNumber}}",
      "openOrderTitle": "Ouvrir le détail de la commande"
    },
    "bulk": {
      "approvalCount": "{{count}} en attente d’approbation",
      "approvalDesc": "Lot mis en attente. Identifiant de demande {{requestId}} ; {{count}} commandes > seuil {{threshold}}.",
      "approvalTitle": "Double approbation requise",
      "exportQueuedDesc": "Tâche d'export {{jobId}} mise en file d'attente pour {{count}} commandes ({{format}}).",
      "exportQueuedTitle": "Export mis en file d'attente",
      "failedCount": "{{count}} en échec",
      "failedTitle": "Échec de l'action groupée",
      "noneAffected": "Aucune commande affectée.",
      "noneSelectedDesc": "Sélectionnez au moins une commande pour exécuter cette action groupée.",
      "noneSelectedTitle": "Aucune commande sélectionnée",
      "okCount": "{{count}} appliqué(s)",
      "queuedCount": "{{count}} en file d'attente",
      "reassignNoneSelectedDesc": "Sélectionnez au moins une commande pour réattribuer le fournisseur en lot.",
      "skippedDesc": "{{count}} commande(s) sélectionnée(s) non éligible(s) à cette action (statut) — ignorée(s)",
      "skippedTitle": "Certaines commandes ignorées",
      "submittedTitle": "Action groupée envoyée",
      "ineligibleVendorChange": "Aucune des commandes sélectionnées ne peut changer de vendeur — les commandes expédiées, livrées, annulées et retournées sont verrouillées.",
      "ineligibleCancel": "Aucune des commandes sélectionnées ne peut être annulée — les commandes expédiées, livrées, annulées et retournées sont verrouillées.",
      "ineligibleResend": "Le renvoi ne s'applique qu'aux commandes livrées ou partiellement retournées."
    },
    "bulkActions": {
      "assign": "Attribuer un fournisseur",
      "cancel": "Annuler",
      "export": "Exporter en CSV",
      "reassign": "Réattribuer le fournisseur en lot",
      "refund": "Rembourser",
      "resend": "Renvoyer"
    },
    "columns": {
      "approved": "Approuvée",
      "items": "Articles",
      "lastUpdated": "Dernière mise à jour",
      "orderId": "ID commande",
      "received": "Reçue",
      "source": "Source",
      "status": "Statut",
      "store": "Boutique",
      "surcharge": "Surcharge",
      "total": "Total",
      "tracking": "Suivi",
      "vendor": "Fournisseur",
      "product": "Produit",
      "platform": "Plateforme",
      "orderType": "Type de commande",
      "merchantEmail": "E-mail marchand",
      "sla": "SLA",
      "resetColumns": "Réinitialiser les colonnes",
      "saveFailedTitle": "Échec de l'enregistrement de la disposition des colonnes",
      "actions": "Actions"
    },
    "filters": {
      "search": {
        "label": "Rechercher",
        "placeholder": "Numéro de commande, ID, suivi…"
      },
      "source": {
        "label": "Source"
      },
      "status": {
        "label": "Statut"
      },
      "store": {
        "label": "Boutique",
        "placeholder": "Toutes les boutiques"
      },
      "payment": {
        "label": "Statut de paiement",
        "placeholder": "Tous les statuts de paiement"
      },
      "artwork": {
        "label": "Statut du visuel",
        "placeholder": "Tous les statuts de visuel"
      },
      "product": {
        "label": "Produit",
        "placeholder": "Rechercher un produit…"
      }
    },
    "unassigned": "Non attribué",
    "empty": "Aucune commande ne correspond à vos filtres.",
    "errors": {
      "network": "Erreur réseau — vérifiez la connexion"
    },
    "manualAssign": "Attribution manuelle",
    "page": {
      "heading": "Commandes",
      "subtitle": "Liste des commandes inter-marchands. Les actions groupées multi-sélection ne s'appliquent qu'à la page courante."
    },
    "prompts": {
      "cancelReason": "Motif d'annulation :",
      "refundReason": "Motif de remboursement :",
      "resendReason": "Motif de renvoi :",
      "saveView": "Enregistrer le filtre actuel sous le nom :",
      "vendorId": "ID fournisseur (24 hex) :"
    },
    "reasonCategories": {
      "capacity_overflow": "Dépassement de capacité",
      "manual_reroute": "Réacheminement manuel",
      "other": "Autre",
      "quality_concern": "Problème de qualité",
      "vendor_downtime": "Indisponibilité du fournisseur"
    },
    "reassign": {
      "appliedDesc": "{{count}} commandes réattribuées à {{vendor}}.",
      "appliedTitle": "Réattribution en lot appliquée",
      "applyFailedTitle": "Échec de l'application",
      "applying": "Application en cours…",
      "aria": "Réattribuer le fournisseur en lot",
      "cancel": "Annuler",
      "categoryLabel": "Catégorie de motif*",
      "cols": {
        "current": "Actuel",
        "error": "Erreur",
        "orderId": "ID commande",
        "status": "Statut"
      },
      "confirmApply": "Confirmer l'application",
      "confirmApplyCount": "Confirmer l'application ({{count}})",
      "description": "{{count}} commandes sélectionnées. Transfert de propriété uniquement — ne déclenche pas de réapprobation. Motif d'au moins {{min}} caractères.",
      "newVendorFallback": "nouveau fournisseur",
      "preview": "Aperçu",
      "previewBatchId": "batchId : {{batchId}}…",
      "previewFailedTitle": "Échec de l'aperçu",
      "previewInvalidVendor": "{{count}} fournisseur invalide",
      "previewOther": "{{count}} autres",
      "previewSkipStatus": "{{count}} ignorées (statut)",
      "previewValid": "{{count}} valides",
      "previewing": "Aperçu en cours…",
      "reasonLabel": "Motif* ({{current}}/{{min}}+ caractères)",
      "reasonPlaceholder": "Justification détaillée (journal d'audit)…",
      "title": "Réattribuer le fournisseur en lot",
      "vendorLabel": "Nouveau fournisseur*",
      "vendorPlaceholder": "Choisir un fournisseur…",
      "hintNoVendor": "Aucune commande sélectionnée n’a de fournisseur à réaffecter. Utilisez « Assign Vendor » pour en définir un d’abord.",
      "hintNoValid": "Aucune commande sélectionnée n’est éligible à la réaffectation."
    },
    "savedViews": {
      "appliedTitle": "Vue enregistrée appliquée",
      "applyPlaceholder": "— Appliquer une vue enregistrée —",
      "archive": "Archives",
      "createdDesc": "\"{{name}}\" — restaurée depuis ce filtre.",
      "createdTitle": "Vue enregistrée créée",
      "deleteFailedTitle": "Échec de la suppression de la vue",
      "deleteLatest": "Supprimer la dernière",
      "deleteLatestTitle": "Supprimer la vue enregistrée la plus récente",
      "deletedTitle": "Vue enregistrée supprimée",
      "label": "Vue enregistrée",
      "saveCurrent": "Enregistrer l'actuelle",
      "saveFailedTitle": "Échec de l'enregistrement de la vue"
    },
    "archive": {
      "_comment": "Phase 3.3 Amendment #3 — Archive custom view (bucket=archive).",
      "badge": "Archives",
      "clear": "Quitter la vue archives",
      "empty": "Aucune commande archivée."
    },
    "toolbar": {
      "importTitle": "Importer un CSV — réattribuer le vendor en masse",
      "export": "Exporter",
      "exporting": "Export en cours…",
      "searchPlaceholder": "Rechercher par n° de commande, email, produit, tracking…",
      "filterPending": "Ce filtre sera activé une fois pris en charge par le BE",
      "productPlaceholder": "Produit",
      "refreshTitle": "Actualiser / effacer les filtres",
      "statusOptions": {
        "placeholder": "Statut",
        "draft": "Brouillon",
        "waiting": "En attente d'approbation",
        "assigned": "Attribuée",
        "in_production": "En production",
        "ready_to_ship": "Prête à expédier",
        "shipped": "Expédiée",
        "delivered": "Livrée",
        "on_hold": "En suspens",
        "cancelled": "Annulée"
      }
    },
    "sla": {
      "overdue": "En retard",
      "dueInDays": "{{days}} j restants",
      "dash": "—"
    },
    "assignModal": {
      "aria": "Affecter un fournisseur aux commandes sélectionnées",
      "title": "Attribuer un fournisseur",
      "description": "Affecter un fournisseur à {{count}} commande(s) sélectionnée(s).",
      "vendorLabel": "Fournisseur",
      "vendorPlaceholder": "Choisir un fournisseur…",
      "cancel": "Annuler",
      "confirm": "Attribuer le fournisseur"
    }
  },
  "modals": {
    "addSurcharge": {
      "amountCentsHint": "Équivaut à {{cents}} cents.",
      "amountError": "Le montant doit être supérieur à 0 avec au plus 2 décimales.",
      "amountLabel": "Montant (USD)",
      "amountPlaceholder": "ex. 12.50",
      "autoPayNotice": "Le marchand a activé le paiement automatique — le supplément sera prélevé automatiquement sur le portefeuille.",
      "cancel": "Annuler",
      "descDefault": "Ajouter un supplément à cette commande.",
      "descWithLabel": "Ajouter un supplément à la commande {{label}}.",
      "enoughChars": "C'est bon",
      "errors": {
        "network": "Erreur de connexion — veuillez réessayer."
      },
      "needMoreChars": "{{count}} caractères supplémentaires requis",
      "paymentCredit": "Crédit",
      "paymentMethodLegend": "Mode de paiement",
      "paymentWallet": "Portefeuille",
      "reasonLabel": "Motif",
      "reasonPlaceholder": "Saisissez un motif (au moins {{min}} caractères)…",
      "submit": "Ajouter le supplément",
      "submitting": "Traitement…",
      "title": "Ajouter un supplément"
    },
    "assign": {
      "blacklist": "Liste noire",
      "cancel": "Annuler",
      "capacityShort": "Capacité {{pct}}%",
      "costGuard": {
        "break_even": "seuil de rentabilité",
        "loss": "perte",
        "profit": "bénéfice"
      },
      "descAssign": "Choisissez un fournisseur pour traiter la commande et ajoutez un motif pour le journal d'audit.",
      "descBulk": "Le fournisseur sélectionné sera appliqué à toute la liste sélectionnée. Les commandes non éligibles tomberont dans la liste des échecs.",
      "descReassign": "Fournisseur actuel : {{vendor}}. Choisissez un nouveau fournisseur et ajoutez un motif.",
      "dualApprovalBanner": "Lot > 5 commandes — une double approbation est requise avant application.",
      "enoughChars": "C'est bon",
      "errors": {
        "network": "Erreur réseau - vérifiez la connexion",
        "suggestionsLoad": "Impossible de charger la liste des suggestions de fournisseurs"
      },
      "needMoreChars": "{{count}} caractères supplémentaires requis",
      "overrideScoreLabel": "Remplacer la suggestion à 5 facteurs (override score)",
      "reasonLabel": "Motif",
      "reasonPlaceholder": "Au moins {{min}} caractères, pour le journal d'audit.",
      "scoreLabel": "Score {{score}}",
      "selectButton": "Choisir",
      "submitAssign": "Affecter le fournisseur",
      "submitBulk": "Affecter à {{count}} commandes",
      "submitReassign": "Changer de fournisseur",
      "submitting": "Affectation…",
      "suggestionsEmpty": "Aucun fournisseur éligible — saisissez un fournisseur manuellement ci-dessous.",
      "suggestionsLoading": "Chargement des suggestions…",
      "suggestionsTitle": "Top 3 suggestions (formule à 5 facteurs)",
      "titleAssign": "Affecter un fournisseur à la commande (affecter)",
      "titleBulk": "Affecter un fournisseur à {{count}} commandes",
      "titleReassign": "Passer à un autre fournisseur (réaffecter)",
      "vendorIdError": "L'ID fournisseur doit être une chaîne hexadécimale de 24 caractères.",
      "vendorIdLabel": "ID fournisseur",
      "vendorIdPlaceholder": "ObjectId de 24 caractères (choisir parmi les suggestions ou coller directement)",
      "whitelist": "Liste blanche"
    },
    "assignmentSimulation": {
      "adjustWeightsHint": "Ajustez les poids pour que la somme soit égale à 1.00 avant de voir les résultats.",
      "allocationBranch": "Cet article est routé selon la part d'allocation : le choix ignore le prix et les préférences.",
      "applyButton": "Appliquer avec le fournisseur sélectionné",
      "applyWord": "Appliquer",
      "cancel": "Annuler",
      "costDesc": "Coût de production de cet article, rapporté au reste du pool.",
      "costLabel": "Coût",
      "descLead": "Simulateur what-if pour le panneau de scoring des fournisseurs. Les résultats ne sont",
      "descMid": "— ils n'affectent que le prochain",
      "descNot": "pas enregistrés",
      "descTail": "avec le fournisseur sélectionné.",
      "errors": {
        "network": "Erreur de connexion — veuillez réessayer.",
        "sumRejected": "Le serveur a refusé ces poids : la somme des quatre axes doit être exactement 1,00 (reçu {{sum}}).",
        "outOfRangeAxes": "Hors plage : {{axes}}"
      },
      "noVendorInPool": "Aucun fournisseur du pool n'est éligible.",
      "notPersistedHint": "La simulation n'est pas enregistrée — elle n'affecte que la prochaine action Apply.",
      "poolSize": "Fournisseurs parmi lesquels le choix serait fait : {{size}}",
      "preferenceApplied": "Le classement de préférence a réordonné les fournisseurs à égalité en tête.",
      "ratingDesc": "La note de qualité du fournisseur.",
      "ratingLabel": "Évaluation",
      "recalculating": "Recalcul…",
      "resetButton": "Revenir aux pondérations en vigueur",
      "ruleContext": {
        "allowNarrowed": "La liste d'autorisation du marchand a retiré des fournisseurs de ce pool.",
        "blocked": "Écartés par les règles de routage du marchand : {{value}}",
        "frozen": "Gelés par un administrateur à cet emplacement : {{value}}",
        "fenced": "Hors du périmètre de l'emplacement : {{value}}",
        "hardFilter": "Écartés par le filtre de capacités : {{value}}",
        "rejected": "Déjà essayés pour cet article : {{value}}",
        "rulesReadFailed": "Les règles de routage du marchand n'ont pas pu être lues : l'article a été retenu au lieu d'être routé au hasard. Il s'agit d'une panne technique et non d'une règle du marchand."
      },
      "slaDesc": "Ponctualité des livraisons par rapport au délai promis.",
      "slaLabel": "SLA",
      "sumWarningPrefix": "La somme des poids doit être égale à 1.00. Actuellement :",
      "title": "Simulation d'affectation (what-if)",
      "tooltipAdjustFirst": "Ajustez les poids à 1.00 pour lancer d'abord la simulation",
      "tooltipSelectVendor": "Sélectionnez un fournisseur dans la liste ci-dessous pour activer",
      "topVendorHeading": "Meilleurs fournisseurs après recalcul",
      "utilizationDesc": "Part de la capacité quotidienne du fournisseur encore libre.",
      "utilizationLabel": "Charge",
      "weightsHeading": "Poids (somme = {{sum}})",
      "weightsLoading": "Lecture des pondérations en vigueur…",
      "weightsSource": {
        "live": "Pondérations en vigueur — exactement ce que le routeur utiliserait pour cet article maintenant.",
        "override": "Votre réglage — aperçu uniquement. Les pondérations en vigueur sont inchangées et rien n'est enregistré."
      },
      "weightsVersion": "Jeu de pondérations v{{version}}"
    },
    "refund": {
      "adminSuffix": " (admin)",
      "alreadyRefunded": "Déjà remboursé",
      "ariaEstimatedRefund": "Remboursement estimé pour {{label}}",
      "ariaRefundScope": "Portée du remboursement",
      "backendPendingBody": "Le remboursement n'a pas pu être créé — le module Phase 4 n'est pas déployé dans cet environnement, ou la commande est introuvable. L'entrée d'audit a été enregistrée localement.",
      "backendPendingTitle": "Backend en attente",
      "bannerAwaitingMid": "est",
      "bannerAwaitingPost": "en attente d'une seconde validation admin.",
      "bannerAwaitingPre": "Le remboursement",
      "bannerPendingDesc": "Les remboursements supérieurs à 500 $ nécessitent une seconde validation admin.",
      "cancel": "Annuler",
      "charsUnit": "caractères",
      "close": "Fermer",
      "description": "Phase 4 gère le backend de remboursement. Cette fenêtre envoie la demande au service canonique ; les fonds sont crédités sur le portefeuille du marchand à la fin.",
      "destinationPrefix": "Destination du remboursement :",
      "destinationSuffix": ". Aucune autre destination n'est prise en charge dans cette version.",
      "destinationWallet": "portefeuille du marchand",
      "errors": {
        "noRefundable": "Aucun article remboursable ne subsiste sur cette commande.",
        "noteTooLong": "La note de motif doit être ≤ {{max}} caractères.",
        "otherRequiresNote": "Le motif \"Autre\" nécessite une note expliquant le remboursement.",
        "qtyExceeds": "La quantité pour \"{{label}}\" dépasse le remboursable restant ({{max}}).",
        "qtyInteger": "La quantité pour \"{{label}}\" doit être un entier non négatif.",
        "requestFailed": "La demande de remboursement a échoué — veuillez réessayer.",
        "selectOne": "Sélectionnez au moins un article avec une quantité > 0."
      },
      "estimatedTotal": "Total estimé",
      "gatewayDefault": "Stripe (par défaut)",
      "lineItems": "Articles",
      "lineItemsFull": "(quantités totales présélectionnées)",
      "lineItemsPartial": "(définir les quantités à rembourser)",
      "maxQty": "(max {{max}})",
      "maxRefundable": "Remboursable max",
      "originalGateway": "Passerelle d'origine",
      "queuedFor": "d'un montant de",
      "queuedIs": "est",
      "queuedPre": "Le remboursement",
      "queuedTitle": "Remboursement mis en file",
      "queuedTo": "vers le portefeuille du marchand.",
      "reasonCodes": {
        "CHANGED_MIND": "Le client a changé d'avis",
        "CUSTOMER_REQUEST": "Demande du client (geste commercial)",
        "DUPLICATE_ORDER": "Commande en double",
        "FRAUD_SUSPECTED": "Fraude suspectée",
        "OTHER": "Autre (justifier dans la note)",
        "POLICY_VIOLATION": "Violation de politique",
        "SYSTEM_ERROR": "Erreur système",
        "VENDOR_FAILURE": "Défaillance du fournisseur",
        "WRONG_ADDRESS": "Mauvaise adresse de livraison",
        "WRONG_ARTWORK": "Mauvais visuel appliqué",
        "WRONG_PRODUCT": "Mauvais produit expédié"
      },
      "reasonLabel": "Motif",
      "reasonNoteLabel": "Note de motif (facultatif, ≤ {{max}} caractères)",
      "reasonNotePlaceholder": "Expliquez le contexte du remboursement pour le journal d'audit…",
      "serverComputed": "(montant final calculé par le serveur)",
      "submitRefund": "Rembourser {{amount}}",
      "submitRequest": "Demander le remboursement ({{amount}})",
      "submitting": "Envoi…",
      "tabFull": "Remboursement total",
      "tabPartial": "Remboursement partiel",
      "title": "Rembourser la commande — {{order}}",
      "toastAwaitingDesc": "Un remboursement > 500 $ nécessite une seconde validation admin.",
      "toastAwaitingTitle": "En attente de l'approbation d'un pair",
      "toastBackendDesc": "Le remboursement n'a pas pu être traité — service Phase 4 pas encore déployé ou commande introuvable.",
      "toastBackendTitle": "Backend en attente",
      "toastFailedTitle": "Échec du remboursement",
      "toastProcessingDesc": "{{order}} — {{amount}} mis en file vers le portefeuille du marchand.",
      "toastProcessingTitle": "Remboursement en cours"
    },
    "resend": {
      "close": "Fermer",
      "costLabels": {
        "platform": "La plateforme paie en totalité (0% fournisseur / 100% plateforme)",
        "shared": "Répartition 50/50 (50% fournisseur / 50% plateforme)",
        "vendor": "Le fournisseur paie en totalité (100% fournisseur / 0% plateforme)"
      },
      "costLegend": "Cost responsibility (qui paie)",
      "costNotice": "Le portefeuille du marchand n'est pas débité (le renvoi ne facture pas le marchand) — le coût est réparti entre le fournisseur et la plateforme.",
      "descDefault": "Créer une nouvelle commande liée à la commande d'origine. Le marchand n'est pas facturé — le coût est réparti selon la cost-responsibility.",
      "descWithNumberPost": ". Le marchand n'est pas facturé (le renvoi ne débite pas le portefeuille du marchand — le coût est réparti selon la cost-responsibility).",
      "descWithNumberPre": "Créer une nouvelle commande liée à la commande d'origine",
      "enoughChars": "C'est bon",
      "errors": {
        "network": "Erreur réseau - vérifiez la connexion"
      },
      "itemsLegend": "Articles à réimprimer",
      "itemsRequired": "Sélectionnez au moins 1 article",
      "needMoreChars": "{{count}} caractères supplémentaires requis",
      "newVendorError": "L'id fournisseur doit être un ObjectId hex de 24 caractères",
      "newVendorPlaceholder": "ex. : 64f0c1a2b3c4d5e6f7a8b9c0",
      "noVendor": "La commande n'a pas encore de fournisseur",
      "previewLabel": "Aperçu du fournisseur de destination :",
      "previewNewEmpty": "(aucun nouveau fournisseur saisi)",
      "previewNoVendor": "— (la commande n'a pas de fournisseur)",
      "previewSameId": "{{id}}… (conserver l'ancien fournisseur)",
      "previewSameNamed": "{{name}} (conserver l'ancien fournisseur)",
      "reasonLabel": "Motif du renvoi",
      "reasonPlaceholder": "Saisissez un motif (au moins {{min}} caractères)…",
      "submit": "Créer la commande de renvoi",
      "submitting": "Création de la nouvelle commande…",
      "targetLegend": "Cible du renvoi (fournisseur de destination)",
      "targetNew": "Passer à un nouveau fournisseur",
      "targetNewHint": "Saisissez un id fournisseur (ObjectId hex de 24 caractères)",
      "targetSame": "Même fournisseur (conserver)",
      "title": "Renvoyer la commande (réimpression)"
    }
  },
  "pendingAssign": {
    "actions": {
      "assign": "Attribution manuelle",
      "assignFailDefault": "Échec de l'attribution manuelle.",
      "cancel": "Annuler",
      "escalate": "Signaler une escalade",
      "escalateFail": "{{fail}} commandes n'ont pas pu être escaladées.",
      "partialResult": "Attribué {{success}}/{{total}} commandes. {{fail}} en échec — voir les détails ci-dessous.",
      "reasonLabel": "Motif",
      "reasonPlaceholder": "Indiquez le motif de l'attribution manuelle pour le journal d'audit",
      "requiredFields": "Veuillez saisir l'ID du fournisseur, le nom du fournisseur et un motif pour l'attribution manuelle.",
      "resultSuccess": "succès",
      "resultUnknownError": "erreur inconnue",
      "selectedPrefix": "Sélectionné",
      "selectedSuffix": "commandes",
      "skip": "Ignorer",
      "submit": "Envoyer",
      "submitting": "Traitement…",
      "vendorIdLabel": "ID du fournisseur",
      "vendorIdPlaceholder": "ObjectId 24-hex",
      "vendorNameLabel": "Nom du fournisseur",
      "vendorNamePlaceholder": "ex. : PrintCo VN",
      "escalateReason": "L'administrateur a demandé une escalade anticipée (manual override)"
    },
    "page": {
      "autoRefresh": "Actualisation automatique toutes les 30 secondes.",
      "columns": {
        "escalated": "Escaladé",
        "items": "Articles",
        "orderId": "Order ID",
        "received": "Reçu",
        "slaRemaining": "SLA restant",
        "status": "Statut",
        "tier": "Niveau d'alerte"
      },
      "description": "File d'attente des commandes qui n'ont pas pu être attribuées automatiquement à un fournisseur. SLA 2 heures — les commandes en retard sont automatiquement escaladées au Super Admin.",
      "empty": "Aucune commande en attente d'attribution manuelle.",
      "escalatedYes": "Oui",
      "heading": "Attribution manuelle en attente",
      "loadError": "Impossible de charger la file d'attente d'attribution manuelle.",
      "loading": "Chargement de la file…",
      "selectAll": "Tout sélectionner",
      "selectRow": "Sélectionner la commande {{orderId}}",
      "tiers": {
        "T1": "Avertissement (1h-2h)",
        "T2": "En retard (2h-4h)",
        "T3": "Urgent (>4h)",
        "none": "Dans les délais"
      }
    }
  },
  "refundPanel": {
    "awaitingApproval": "En attente de la double approbation.",
    "backendPending": "Les remboursements apparaîtront ici après le déploiement du module Phase 4.",
    "defaultTitle": "Historique des remboursements",
    "empty": "Aucun remboursement n'a encore été émis pour cette commande.",
    "errorFallback": "Échec du chargement de l'historique des remboursements.",
    "loading": "Chargement des remboursements…",
    "refreshing": "Actualisation…",
    "statusLabels": {
      "approved": "Approuvé",
      "failed": "Échoué",
      "pending": "En attente",
      "processed": "Traité",
      "rejected": "Rejeté"
    }
  },
  "rightColumn": {
    "financialSummary": {
      "cogs": "COGS (coût des marchandises)",
      "costGatedBadge": "limité aux coûts",
      "margin": "Marge",
      "naValue": "N/A",
      "payoutsPending": "Versements en attente",
      "perItemRow": "{{item}} · fournisseur {{vendor}}",
      "perItemSummary": "Coût fournisseur par article ({{count}})",
      "revenue": "Chiffre d'affaires",
      "title": "Résumé financier"
    },
    "merchantInfo": {
      "customer": "Client",
      "email": "E-mail",
      "phone": "Téléphone",
      "title": "Marchand"
    },
    "paymentInfo": {
      "grandTotal": "Total de la commande",
      "placeholderHint": "Le lien de la transaction apparaîtra une fois la Phase 8.2 déployée.",
      "title": "Paiement",
      "viewTransaction": "Voir la transaction →"
    },
    "statusActions": {
      "actions": {
        "assign": "Attribuer / Réattribuer",
        "cancel": "Annuler la commande",
        "refund": "Rembourser",
        "resend": "Renvoyer",
        "surcharge": "Ajouter un supplément"
      },
      "statusLabels": {
        "accepted": "Acceptée",
        "assigned": "Attribuée",
        "cancelled": "Annulée",
        "confirmed": "Confirmée",
        "delivered": "Livrée",
        "draft": "Brouillon",
        "in_production": "En production",
        "on_hold": "En attente",
        "pending_emb_payment": "Paiement EMB en attente",
        "pending_payment": "Paiement en attente",
        "pending_reassignment": "Réattribution en attente",
        "returned": "Retournée",
        "shipped": "Expédiée"
      },
      "title": "Statut"
    },
    "vendorScore": {
      "alternatives": "Alternatives (top {{count}})",
      "assignedBadge": "Attribué",
      "contributionNote": "La valeur à droite du signe = est la contribution pondérée. La somme des contributions = score total.",
      "costAxisLabel": "Axe de coût normalisé (0–1) et coût de production du fournisseur pour cette commande.",
      "costNotDeclared": "Aucun coût déclaré",
      "errorNetwork": "Erreur réseau - vérifiez la connexion",
      "factors": {
        "cost": "Coût",
        "rating": "Évaluation",
        "sla": "SLA",
        "utilization": "Taux d'occupation"
      },
      "formulaBodyV3": " — score = évaluation × {{rating}} + taux d'occupation × {{utilization}} + SLA × {{sla}} + coût × {{cost}}.",
      "formulaLink": "{{version}} (§6.13 Règles d'attribution des commandes)",
      "formulaPrefix": "Formule",
      "heading": "Analyse du score fournisseur",
      "legacyBadge": "Ancienne",
      "legacyExplain": "Cette attribution a été notée avant l'existence de l'axe de coût ; aucun coût n'a donc été enregistré.",
      "loading": "Chargement de l'analyse…",
      "noScored": "Aucun fournisseur n'a encore été noté pour cette commande.",
      "rerunButton": "Recalculer le score (test des poids — non enregistré)",
      "retry": "Réessayer",
      "totalLabel": "Total",
      "weightsProvenance": "Poids en vigueur au moment de l'attribution — pas ceux d'aujourd'hui.",
      "weightsVersion": "Jeu de poids v{{version}}",
      "weightsVersionUnknown": "Jeu de poids : aucun enregistré",
      "weightsVersionFallback": "valeurs par défaut — aucun jeu approuvé lisible",
      "multiItemNotice": "Ceci explique un article sur {{count}} de la commande. Chaque article est routé séparément sur son propre pool de vendeurs ; les scores d'articles différents ne sont pas comparables.",
      "unknownVendor": "Fournisseur n'existe plus"
    },
    "vendors": {
      "empty": "Aucun fournisseur attribué pour le moment.",
      "itemCount_one": "{{count}} article",
      "itemCount_other": "{{count}} articles",
      "title": "Fournisseurs",
      "vendorFallback": "Fournisseur #{{id}}"
    },
    "production": {
      "stateLabels": {
        "in_production": "En production",
        "quality_check": "Contrôle qualité",
        "ready_to_ship": "Prêt à expédier"
      },
      "vendorUnassigned": "Aucun vendor assigné",
      "empty": "Aucun article n'est encore en production."
    },
    "salesPerson": {
      "unassigned": "Non assigné",
      "attributionPending": "Attribution — en attente du backend (Task 53 / D-494)."
    },
    "vendorPushAlerts": {
      "stuckPre": "Commande bloquée en",
      "stuckPost": "depuis {{days}} jours (seuil {{threshold}} jours).",
      "rejectPre": "Poussée vendor vers",
      "rejectPost": "a été refusée",
      "missingFields": "— manquant : {{fields}}"
    }
  },
  "settings": {
    "policyStub": "SLA et politique de commande — bientôt disponible.",
    "tabs": {
      "bulk": "Outils en masse",
      "policy": "Politique"
    }
  },
  "paymentStatusLabels": {
    "paid": "Payé",
    "partial": "Partiel",
    "pending": "En attente",
    "refunded": "Remboursé",
    "unpaid": "Impayé"
  },
  "sourceLabels": {
    "api": "API",
    "etsy_import": "Etsy",
    "manual_admin": "Créée par l'admin",
    "merchant_dashboard": "Créée par le marchand",
    "other": "Autre",
    "partner_api": "API partenaire",
    "shopify_import": "Shopify",
    "tiktok_import": "TikTok"
  },
  "statusLabels": {
    "accepted": "Acceptée",
    "assigned": "Attribuée",
    "attention_required": "Attention requise",
    "cancelled": "Annulée",
    "confirmed": "Confirmée",
    "delivered": "Livrée",
    "draft": "Brouillon",
    "in_production": "En production",
    "on_hold": "En suspens",
    "partially_cancelled": "Partiellement annulée",
    "partially_shipped": "Partiellement expédiée",
    "pending_emb_payment": "Paiement broderie en attente",
    "pending_payment": "Paiement en attente",
    "pending_reassignment": "Réattribution en attente",
    "quality_check": "Contrôle qualité",
    "ready_to_ship": "Prête à expédier",
    "returned_partial": "Retour partiel",
    "shipped": "Expédiée",
    "unknown": "Inconnu"
  },
  "tabs": {
    "aria": "Onglets de commandes",
    "descriptions": {
      "all": "Toutes les commandes, tous marchands confondus.",
      "cancelled": "Annulées ou partiellement annulées (transitoire).",
      "delivered": "Livrées au client.",
      "draft_unpaid": "Brouillons et commandes en attente de paiement.",
      "issues": "En attente / réassignation / retour partiel — sous-filtres de puces.",
      "pending": "Confirmées / assignées / acceptées par le vendeur.",
      "pending_manual_assign": "le répartiteur automatique a échoué ; l'admin doit choisir un vendeur manuellement.",
      "processing": "En production / contrôle qualité / prêtes à expédier.",
      "resent": "Articles réexpédiés (transitoire).",
      "shipped": "Expédiées (totalement ou partiellement).",
      "unassigned": "Commandes confirmées en attente d'assignation à un vendeur."
    },
    "labels": {
      "all": "Toutes",
      "cancelled": "Annulées",
      "delivered": "Livrées",
      "draft_unpaid": "Brouillon / Impayée",
      "issues": "Problèmes",
      "pending": "En attente",
      "pending_manual_assign": "Assignation manuelle en attente",
      "processing": "En traitement",
      "resent": "Réexpédiées",
      "shipped": "Expédiées",
      "unassigned": "Non assignées"
    }
  },
  "timeline": {
    "aria": "Statut de la commande",
    "cancelledBanner": "Commande annulée / retournée — le cycle de traitement ne s'applique plus.",
    "statusLabels": {
      "approval": "Approbation",
      "delivered": "Livrée",
      "new": "Nouvelle",
      "production": "En production",
      "shipped": "Expédiée",
      "assigned": "Attribuée",
      "accepted": "Acceptée",
      "quality_check": "Contrôle qualité",
      "ready_to_ship": "Prête à expédier"
    },
    "issuePrefix": "Attention requise — ",
    "issueLabels": {
      "error-artwork": "Erreur d'artwork",
      "unverified": "Adresse non vérifiée",
      "on_hold": "En attente",
      "attention_required": "Attention requise",
      "pending_reassignment": "Réattribution en attente",
      "unknown": "État inconnu"
    }
  },
  "vendorOverride": {
    "cancel": "Annuler",
    "categoryLabel": "Catégorie de raison*",
    "hint": "Remplacer le fournisseur pour cette commande. Raison ≥ {{min}} caractères + choisir une catégorie. PAS de ré-approbation.",
    "reasonCategories": {
      "capacity_overflow": "Dépassement de capacité",
      "manual_reroute": "Réacheminement manuel",
      "other": "Autre",
      "quality_concern": "Problème de qualité",
      "vendor_downtime": "Indisponibilité du fournisseur"
    },
    "reasonCounter": "{{current}} / {{min}} caractères minimum",
    "reasonLabel": "Raison (≥ {{min}} caractères)*",
    "submit": "Remplacer le fournisseur",
    "submitting": "Remplacement…",
    "title": "Modifier le fournisseur (override unique)",
    "toast": {
      "errorDefault": "Échec du remplacement du fournisseur",
      "errorInvalidCategory": "Catégorie de raison invalide",
      "errorNoVendor": "La commande n'a pas de fournisseur — utilisez Attribuer au lieu de Override",
      "errorNoop": "Le nouveau fournisseur est identique au fournisseur actuel",
      "errorReasonTooShort": "La raison doit comporter au moins {{min}} caractères",
      "errorStatusLocked": "La commande est passée en expédition",
      "successDesc": "Le nouveau fournisseur a été attribué à la commande (PAS de ré-approbation).",
      "successTitle": "Fournisseur remplacé"
    },
    "vendorLabel": "Nouveau fournisseur*",
    "vendorPlaceholder": "Choisir un fournisseur…"
  },
  "common": {
    "close": "Fermer"
  },
  "orderType": {
    "BASIC": "De base",
    "SAMPLE": "Échantillon",
    "BULK_FBA_FBT": "En gros (FBA/FBT)",
    "BUNDLE": "Lot"
  },
  "artworkLabels": {
    "ok": "Visuel OK",
    "missing": "Visuel manquant"
  },
  "promoBanner": {
    "title": "Achetez plus, économisez plus avec les remises en gros !",
    "subtitle": "Commandez 10+ articles et bénéficiez de jusqu'à 15% de réduction sur la livraison & les produits.",
    "itemsOrdered": "Articles commandés",
    "itemsOrderedValue": "10+ articles",
    "shippingDiscount": "Remise sur la livraison",
    "shippingDiscountValue": "Jusqu'à 10%",
    "productDiscount": "Remise sur les produits",
    "productDiscountValue": "Jusqu'à 5%",
    "learnMore": "En savoir plus",
    "goToSettings": "Aller aux paramètres",
    "settings": {
      "routing": "Routage :",
      "disabled": "Désactivé",
      "approval": "Approbation :",
      "automatic": "Automatique",
      "trackingNotifications": "Notifications de suivi :",
      "delayedOrders": "Commandes retardées :",
      "manual": "Manuel"
    }
  },
  "inlineVendor": {
    "assign": "Attribuer",
    "reassign": "Réattribuer",
    "assignedFallback": "Attribué",
    "unpaidTooltip": "Le fournisseur ne peut être attribué qu'après paiement de l'article",
    "toast": {
      "successTitle": "Fournisseur mis à jour",
      "errorDefault": "Impossible de mettre à jour le fournisseur",
      "errorUnpaid": "Article non payé — le paiement est requis d'abord",
      "errorConflict": "L'article a changé dans un autre onglet — rechargez et réessayez",
      "errorNoop": "C'est déjà le fournisseur actuel",
      "errorLocked": "Le fournisseur ne peut pas être changé à ce stade",
      "errorNoVendor": "Cet article n'a pas encore de fournisseur — attribuez-en un"
    },
    "dialog": {
      "assignTitle": "Attribuer un fournisseur à l'article",
      "reassignTitle": "Réattribuer le fournisseur de l'article",
      "vendorPlaceholder": "Rechercher un fournisseur…",
      "reasonCategoryLabel": "Catégorie de raison",
      "reasonLabel": "Raison (min {min} caractères)",
      "reasonPlaceholder": "Pourquoi ce fournisseur ?",
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "saving": "Enregistrement…"
    },
    "reasonCategories": {
      "capacity_overflow": "Surcharge de capacité",
      "vendor_downtime": "Indisponibilité du fournisseur",
      "manual_reroute": "Réacheminement manuel",
      "quality_concern": "Problème de qualité",
      "other": "Autre"
    }
  },
  "_vgBinding": "vg-binding: P8.1.1.D-15 — clés i18n pour les nouvelles colonnes de la liste de commandes (product/platform/orderType/merchantEmail/sla), libellés de la cellule SLA, libellés enum type de commande + visuel (valeurs en anglais), et libellés de filtre store/payment/artwork/product pour en/vi/fr [task-11]",
  "capabilityReasons": {
    "canRefund": {
      "preAssign": "Commande non payée — aucune transaction à rembourser",
      "terminal": "Commande dans un état final — remboursement impossible"
    },
    "canCancel": {
      "terminal": "Commande dans un état final",
      "shipped": "Commande remise au transporteur — annulation impossible"
    },
    "canResend": "Le renvoi n'est possible qu'une fois la commande livrée ou retournée (return-to-sender)",
    "canReassign": "La commande est expédiée ou dans un état final — le vendeur ne peut plus être changé",
    "canEscalate": "Commande dans un état final — aucune escalade nécessaire",
    "canReassignPreAssign": "La commande n'est pas encore payée — aucun vendeur ne peut être assigné"
  },
  "reasons": {
    "BLOCKED_BY_MERCHANT_RULE": "Les règles de routage propres au marchand n'ont laissé aucun fournisseur éligible : l'article attend une affectation manuelle.",
    "MERCHANT_RULES_UNAVAILABLE": "Les règles de routage du marchand n'ont pas pu être lues : l'article a été retenu au lieu d'être routé au hasard. Il s'agit d'une panne technique et non d'une règle du marchand — vérifiez le service avant de modifier la moindre règle.",
    "NO_VENDOR_FOR_LOCATION": "Aucun fournisseur n'est lié à cet emplacement pour cette variante : l'article attend une affectation manuelle.",
    "NO_VENDOR_MATCH": "Aucun fournisseur ne correspond à cet article : il attend une affectation manuelle.",
    "VENDOR_LOCATION_FROZEN": "Tous les fournisseurs de cet emplacement sont gelés par un administrateur : l'article attend une affectation manuelle. Dégelez-en un dans l'onglet Emplacements du fournisseur, ou affectez à la main."
  }
}
